var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "box" }, [
    _c("div", [
      _c(
        "div",
        {
          directives: [
            {
              name: "demo",
              rawName: "v-demo",
              value: "getQueryList",
              expression: "'getQueryList'",
            },
          ],
          staticClass: "topBox",
          class: _vm.isHideTop && "hide",
        },
        [
          _c("i", { staticClass: "kf1" }, [
            _c("img", { attrs: { src: _vm.kf1 } }),
          ]),
          _c("span", [_vm._v(_vm._s(_vm.i18nRender("layouts.onlineservice")))]),
        ]
      ),
      _c(
        "i",
        {
          staticClass: "kf1Arrow",
          class: _vm.isHideTop && "rotate180",
          on: {
            click: function ($event) {
              _vm.isHideTop = !_vm.isHideTop
            },
          },
        },
        [_c("img", { attrs: { src: _vm.kf1Arrow } })]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }